<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, useTemplateRef } from 'vue';
import { Creator, ErrorCorrectionLevel, Renderer  } from 'easy-qrcode';


const props = defineProps<{
    url: string
}>()

const matrix = ref();
const qrcode = useTemplateRef('qrcode')

onMounted(() => {

    //create matrix
    const qrCreator = new Creator({
      errorCorrectionLevel: ErrorCorrectionLevel.M,
    });
    qrCreator.add(props.url);
    qrCreator.create();
    matrix.value = qrCreator.getMatrix(); 

    // render matrix
    const qrRenderer = new Renderer();
    const canvas = qrRenderer.drawCanvas(matrix.value);

    if (qrcode.value) {
        qrcode.value?.focus();
        qrcode.value.append(canvas);
    }
});

onBeforeUnmount(() => {
    if (matrix) {
        if (qrcode.value) {
            qrcode.value.innerHTML = '';
        }
        matrix.value = null;
    }
})
</script>

<template>
    <div id="qr-code" data-testid="qr-code" ref="qrcode"></div>
</template>